import React from 'react';
import ClosableMessage from '../../common2/ClosableMessage';

function TakeActionPanelError({ children }) {
  return (
    <div role="alert">
      <ClosableMessage intent="danger">{children}</ClosableMessage>
    </div>
  );
}

export default React.memo(TakeActionPanelError);
